import { autosave } from './autosave';
import { getDateFields } from './getDateFields';
import { getFields } from './getFields';
import { getSchema } from './getSchema';
import { parseFields } from './parseFields';
import { parseJotformDates } from './parseJotformDates';
import { stripCheckboxFalseValues } from './stripCheckboxFalseValues';
import { submitForm } from './submitForm';
import { submitReform } from './submitReform';

const DocumentService = {
  getFields,
  parseFields,
  submitForm,
  autosave,
  getDateFields,
  parseJotformDates,
  stripCheckboxFalseValues,
  getSchema,
  submitReform,
};

export default DocumentService;
